/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';
import {FormattedDate} from 'react-intl';

const LocalDate = ({ data }) => (
    data ? <FormattedDate
        value={data}
        day='2-digit'
        month='2-digit'
        year="numeric"
    />:null
);

export default LocalDate;


/** WEBPACK FOOTER **
 ** ./src/components/LocalDate.jsx
 **/